<template>
  <v-container grid-list-xs>
   <v-divider ></v-divider>
    <v-layout row wrap>
        <v-flex md6> 
           <datosgeneralesempresa/>
           </v-flex>
        <v-flex md6>
          <datosgestiondePago/>
        </v-flex>
    </v-layout>

 <v-divider class="mt-6"></v-divider>
 <v-card>
        <v-text-field
        class="pa-3 mx-2"
      prepend-icon="fas fa-save"
      v-model="mensaje"
      label="MENSAJE INICIO"
     @click:prepend="grabamensaje1()"

    ></v-text-field>
 </v-card>

  <v-card
            class="mx-auto mt-12"
            color="white"
        >
          <v-card-title primary-title>
            COMPONENTES ADICIONALES
          </v-card-title>
          <v-card-text>
             <v-row class="mt-n2">
                <v-col cols="6" xs="6">
                 <v-switch v-model="ofertashome" label="Carrusel Ofertas"></v-switch>
                  <strong class="red--text"> {{tienda.carruselofertas}} </strong>
                </v-col>
                <v-col cols="6" xs="6">
                   <v-switch v-model="cabeceramultimagen" label="Cabecera Multimagen"></v-switch>
              <strong class="red--text"> {{tienda.cabeceramultimagen}} </strong>
                </v-col>
             </v-row>
          </v-card-text>
                
        <v-card-actions class="mt-n6">
            <v-btn
             :disabled="disabled"
              block
              color="success"
              class="mr-4"
              @click="grabacomponente"
              >
              Grabar
            </v-btn>
        </v-card-actions>
        </v-card>
<v-divider></v-divider>

<v-card>    <p class="text-center title">Cabecera deslizable</p>
  <v-card-title class="mt-n2">

                <v-file-input
                class="mr-4"
                label="File input"
                filled
                v-model="selectedFile"
                prepend-icon="mdi-camera"
              ></v-file-input>
              <v-btn color="success"
              @click="grabarimagencarrucel()"
               class="mt-n5">Agrega</v-btn>
              <v-card-text>
                  <v-flex xs12 class="pa-2">
                        <v-row  no-gutters>
                    <v-col
                        v-for="cate in slides"  v-bind:key="cate['.key']"
                        cols="6"
                        xs="6"
                        sm="4"
                        md="3">

                        <v-card
                        class="pa-3 font-italic text-center"
                        outlined
                        tile
                        >
                                <v-img
                                class="text-left"
                                :src="cate.foto"
                                aspect-ratio="1"
                                >
                                <v-btn 
                                @click="eliminacarrucel(cate.id)"
                                text>
                                <v-icon color="red">fas fa-trash-alt</v-icon>
                                </v-btn>
                                <template v-slot:placeholder>
                                    <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                                </v-img>
                        </v-card>
                    </v-col>
                    </v-row>
        </v-flex>
              </v-card-text>
  </v-card-title>
    <v-dialog
            v-model="progress"
            max-width="200"
            >
            <v-card>
                 <v-progress-circular
                  :rotate="90"
                  :size="200"
                  :width="15"
                  :value="Uploadvalue"
                  color="red"
                >
                  {{ Uploadvalue }}
                </v-progress-circular>
            </v-card>

         </v-dialog>
</v-card>
     





 <v-divider ></v-divider>

</v-container>

</template>

<script>
// @ is an alias to /src
import { db } from '../db'
import firebase from 'firebase'
import datosgeneralesempresa from '@/components/datosgeneralesempresa'
import datosgestiondePago from '@/components/datosgestiondePago'

export default {
  name: 'gestionconfiguratienda',

  components: {
    datosgeneralesempresa,
    datosgestiondePago
  },
      firebase: {
        slides: db.database().ref("slide"),
        tienda: db.database().ref("tienda"),
      },

  data(){
    return{
      tienda:'',
      slides:[],
      mensaje:'',
      progress: false,
       Uploadvalue:0,
      selectedFile:null,
      ofertashome:false,
      cabeceramultimagen:false
    }
  },

  methods: {
    grabacomponente(){
            db.database().ref("tienda").child("carruselofertas").set(this.ofertashome);
            db.database().ref("tienda").child("cabeceramultimagen").set(this.cabeceramultimagen);
    },
        grabamensaje1(){
            db.database().ref("tienda").child('mensajehome').set(this.mensaje)
        },
        eliminacarrucel(id){
            db.database().ref("slide").child(id).remove()
            var desertRef = db.storage().ref(`/slide/${id}`)
              desertRef.delete().then(function() {
                console.log("exito")
              }).catch(function(error) {
                  console.log("fallo", error)
              });


        },

        grabarimagencarrucel(){
          var idunica = this.create_UUID()
        this.progress = true
         const storageRef = db.storage().ref(`/slide/${idunica}`)
         const task=storageRef.put(this.selectedFile)
         task.on('state_changed',snapshot=>{
      
           let porcentaje = (snapshot.bytesTransferred/snapshot.totalBytes)*100
           this.Uploadvalue = porcentaje
         },error=>{console.log(error.message)},
         ()=>{this.Uploadvalue=100;
              task.snapshot.ref.getDownloadURL().then((url)=>{
                this.picture = url;

                db.database().ref("slide").child(idunica).set({
                    id:idunica,
                    foto:this.picture,
                    });
                this.selectedFile='',
                this.progress = false
              })
         }
         )
        },
          create_UUID(){
              var dt = new Date().getTime();
              var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                  var r = (dt + Math.random()*16)%16 | 0;
                  dt = Math.floor(dt/16);
                  return (c=='x' ? r :(r&0x3|0x8)).toString(16);
              });
              return uuid;
          },

    },
}
</script>
